export enum TimestampStatus {
    CREATED = "CREATED",
    FAILED = "FAILED",
    CONCLUDED = "CONCLUDED",
}

export interface Timestamp {
    trusted: boolean;
    fileName: string;
    currentStatus: TimestampStatus;
    userId: number;
    timestampRequestedAt?: Date;
    deletedAt?: Date;
    createdAt: Date;
}

export interface TimestampState {
    timestamps?: Timestamp[];
    total: number;
}
